

















































import { Component, Vue, Ref } from 'vue-property-decorator';
import { projectManage } from './project';
import { timeFormat } from '@/utils/other';
import ProjectModal from './components/projectModal.vue';

type IProjectInfo = IProject.IResponse.IProjectInfo;

const columns = [
  {
    slots: { title: 'nameTit' },
    dataIndex: 'name',
    width: '12%',
  },
  {
    slots: { title: 'createdNameTit' },
    dataIndex: 'createdName',
    scopedSlots: { customRender: 'createdName'},
    width: '15%',
    align: 'center',
  },
  {
    slots: { title: 'teamsTit' },
    dataIndex: 'teams',
    scopedSlots: { customRender: 'teams'},
    width: '30%',
  },
  {
    slots: { title: 'managersTit' },
    dataIndex: 'managers',
    scopedSlots: { customRender: 'managers'},
    width: '28%',
  },
  {
    slots: { title: 'isActiveTit' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'isActive'},
    width: '5%',
    align: 'center',
  },
  {
    slots: { title: 'actionTit' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '10%',
    align: 'center',
  },
];

@Component({
  name: 'Project',
  filters: {
    timeFormat,
  },
  components: {
    ProjectModal,
  },
})
export default class Project extends Vue {
  @Ref() private readonly projectModal!: ProjectModal;
  private projectManage = projectManage;
  private columns = columns;
  private selectedKeys: string[] = [];
  private pagination = {
    pageSize: 10,
    hideOnSinglePage: true,
  };
  private spinning = false;
  get projectList() {
    return this.projectManage.tableData;
  }
  private created() {
    this.refreshProjects();
  }
  private destroyed() {
    projectManage.clearData();
  }
  private refreshProjects() {
    this.spinning = true;
    projectManage.requestGetProjects().then((res) => {
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private createProject() {
    projectManage.createProject();
    this.projectModal.showModal();
  }
  private editProject(project: IProjectInfo) {
    projectManage.editProject(project);
    this.projectModal.showModal();
  }
  private editTeams(project: IProjectInfo, type: 'add' | 'del') {
    projectManage.editProject(project);
    this.projectModal.showModal('edit-teams', type);
  }
  private editManagers(project: IProjectInfo, type: 'add' | 'del') {
    projectManage.editProject(project);
    this.projectModal.showModal('edit-managers', type);
  }
  private deleteProject(projectId: string) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(projectId);
      },
    });
  }
  private submitDelete(projectId: string) {
   projectManage.requestDeleteProject(projectId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
}
